import React, { Component } from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import InfiniteScroll from 'react-infinite-scroll-component';
import Page from '../Page/Page';
import RefreshButton from '../RefreshButton/RefreshButton';
import OstolaskuRow from '../Ostolasku/OstolaskuRow';

@inject('ostolaskuStore')
@withRouter
@observer
class Ostolaskut extends Component {
  @observable contentEl;
  @observable scrollParentRef;

  componentDidMount() {
    this.props.ostolaskuStore.fetchIndex();

  }

  @action
  contentMounted = (el) => {
    this.contentEl = el;
    this.props.ostolaskuStore.pageContentRef = el;
  }


  render() {
    const { ostolaskuStore } = this.props;

    const items = ostolaskuStore.list;

    return (
      <Page
        title="Ostolaskut"
        searchActive={ostolaskuStore.searchActive}
        searchValue={ostolaskuStore.searchValue}
        searchPlaceholder="Hae toimittajan ostolaskuja"
        onSearchClose={ostolaskuStore.closeSearch}
        onSearchChange={ostolaskuStore.searchChange}
        forbidden={!ostolaskuStore.hasModule}
        error={!items && ostolaskuStore.indexError}
        loading={ostolaskuStore.isLoadingIndex || ostolaskuStore.isSearching}
        onRetry={ostolaskuStore.fetchIndex}
        empty={(items && items.confirmed && !items.confirmed.length && items.unapproved && !items.unapproved.length && items.unpaid && !items.unpaid.length) || (ostolaskuStore.searchActive && ostolaskuStore.searchResults && !ostolaskuStore.searchResults.length)}
        contentRef={this.contentMounted}
        scrollTop={ostolaskuStore.scrollTop}
        actions={
          <div className="row">
            <IconButton onClick={ostolaskuStore.toggleSearch} color="inherit">
              <SearchIcon />
            </IconButton>

            <RefreshButton
              loading={ostolaskuStore.isLoadingIndexBackground}
              onClick={ostolaskuStore.refreshIndex}
            />
          </div>
        }
      >
        {
          // If [searchActive] and there is [ ostolaskuStore.searchResults] show the results in a [List]
          (ostolaskuStore.searchActive && ostolaskuStore.searchResults) ?
            <div >
              <List>
                {
                  <InfiniteScroll
                    next={ostolaskuStore.fetchMoreSearch}
                    hasMore={ostolaskuStore.searchHasMore}
                    endMessage={<div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}><h3>Ei enempää tuloksia</h3></div>}
                    // This needs to be set or the loading will bug and show another bar
                    dataLength={ostolaskuStore.searchResults.length}
                    loader={
                      <div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}>
                        {<div >
                          <CircularProgress />
                        </div>}
                      </div>
                    }
                    scrollableTarget="searchScrollDiv"

                    initialScrollY={ostolaskuStore.scrollIntoView}
                  >
                    {
                      ostolaskuStore.searchResults &&
                      !!ostolaskuStore.searchResults.length &&
                      ostolaskuStore.searchResults.map((item, idx) =>
                        <OstolaskuRow key={idx} data={item} />
                      )
                    }
                  </InfiniteScroll>
                }
              </List>

            </div> :

            <div >
              {
                items ?
                  <div>
                    {
                      items.unapproved &&
                      !!items.unapproved.length &&
                      <div>
                        <Typography component={'span'} variant="body1" className="padding-sm" style={{ opacity: .8, marginTop: 16 }}>
                          Odottaa hyväksyntää
                    </Typography>

                        <List>
                          {
                            items.unapproved.map((item, idx) =>
                              <OstolaskuRow key={idx} data={item} />
                            )
                          }
                        </List>
                      </div>
                    }

                    {
                      items.unpaid &&
                      !!items.unpaid.length &&
                      <div>
                        <Typography component={'span'} variant="body1" className="padding-sm" style={{ opacity: .8, marginTop: 16 }}>
                          Menossa maksuun
                    </Typography>

                        <List>
                          {
                            items.unpaid.map((item, idx) =>
                              <OstolaskuRow key={idx} data={item} />
                            )
                          }
                        </List>
                      </div>
                    }

                    <Typography component={'span'} variant="body1" className="padding-sm" style={{ opacity: .8, marginTop: 16 }}>
                      Maksettu
                </Typography>
                    <List>
                      {
                        this.contentEl &&
                        <InfiniteScroll
                          next={ostolaskuStore.fetchMore}
                          hasMore={ostolaskuStore.indexHasMore}
                          // This needs to be set or the loading will bug and show another bar
                          dataLength={items.confirmed.length}
                          endMessage={<div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}><h3>Ei enempää tuloksia</h3></div>}
                          loader={
                            <div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}>
                              {<div >
                                <CircularProgress />
                              </div>}
                            </div>
                          }
                          scrollableTarget={this.contentEl}

                          initialScrollY={ostolaskuStore.scrollIntoView}
                        >
                          {
                            items.confirmed &&
                            !!items.confirmed.length &&
                            items.confirmed.map((item, idx) =>
                              <OstolaskuRow key={idx} data={item} />
                            )
                          }
                        </InfiniteScroll>
                      }
                    </List>
                  </div>
                  :

                  <span></span>
              }
            </div>
        }
      </Page>
    );
  }
}

export default Ostolaskut;
